export default __webpack_public_path__ + "static/media/p19.e385c812.jpeg";